import React, { useEffect, useState} from 'react';
import { Grid, makeStyles, Typography, TextField } from "@material-ui/core";
import Selecao from "../../../shared/components/Selecao";
import SelecaoData from "../../../shared/components/SelecaoData";
import SelecaoHora from '../../../shared/components/SelecaoHora';
import { useFormikContext } from 'formik';
import {
    LIMITE_CHARS_ESPECIFICACAO,
    LIMITE_CHARS_NOME_PACIENTE,
    LIMITE_CHARS_NUMERO_PEDIDO,
    TAMANHO_MAXIMO_ARQUIVOS_AMOSTRA,
    EXTENSOES_ARQUIVOS_AMOSTRA
} from "../../../shared/utils/Constantes";
import { criarCampoComMascara, criarCampoComMascaraCPF, MASCARA_NUMERO_ETIQUETA } from "../../../shared/utils/Mascara";
import DropzoneArquivos from "../../../shared/components/DropzoneArquivos";
import { RED, LIGHT_GRAY_COLOR } from '../../../theme';
import ListagemArquivos from './ListagemArquivos';
import { unidadeFederativa, sexos } from "../../../shared/utils/Enum";
import AutoComplete from '../../../shared/components/Autocomplete';
import {
    getOptionSolicitantesLabel,
    getOptionSolicitantesValue
  } from "../../../shared/utils/Formatacao";

import { DadosExame } from '../../dadosExame';
import { useDadosExame } from '../customHooks/useExame';


const DadosCadastroAmostra = ({
    tiposConservacao,
    disableEmpresas,
    defaultEmpresa,
    tiposAmostra,
    empresas,
    camposTiveramFoco,
    setCamposTiveramFoco,
    numeroEtiquetaRef,
    handleErroArquivo,
    handleSucessoArquivos,
    arquivos,
    handleBaixarArquivo,
    handleExcluirArquivo,
    handleChangeSolicitante,
    dadosSolicitante,
    atualizarListaSolicitantes,
    listConvenio,
    clienteDGKPSC,
    ufLaboratorio,
    possuiArquivoPedidoMedico,
    possuiArquivoDiversos,
}) => {
    const classes = useStyles();
    const { values, errors, setFieldValue } = useFormikContext();
    const [ufSolicitante, setUfSolicitante] = useState("");
    const [desativarUf, setDesativarUf] = useState(false);
    const [material, setMaterial] = useState(null);
    const [empresa, setEmpresa] = useState(null);
    
    const dadosSelecaoExame = useDadosExame(null);
    const [listaConvenio, setListaConvenio] = useState([]);;

    const loadOptions = uf => async inputValue => {
        if (!inputValue) {
          return [];
        }
        return atualizarListaSolicitantes(inputValue, uf);
    };  
    
    useEffect(() => {
        if (disableEmpresas) {
            setFieldValue('empresa', defaultEmpresa);
            setEmpresa(defaultEmpresa);
        }
    }, [disableEmpresas, defaultEmpresa]);

    useEffect(()=>{
        if (empresa !== values.empresa && empresa !== null)
            setFieldValue('empresa', empresa);
    }, [empresa]);

    useEffect(() => {
        values.dadosSolicitante = dadosSolicitante
        if(values.dadosSolicitante.length === 1
            && values.dadosSolicitante[0].nome !== ""){
                 setDesativarUf(true)
            }
        else{
             setDesativarUf(false)
        }
           
    },[dadosSolicitante, values.dadosSolicitante]);

    const handleInserirExame = (dados, exames) => {
        if (dados?.exame?.material && dados?.exame?.mnemonico && values) {
            setFieldValue('exames', exames);
            
            if (!material) {                
                setMaterial(dados.exame.material);         
                setFieldValue('material', dados.material);       
                setFieldValue('especificacao', dados.especificacao);
            }
        }

        if (!exames || exames?.length === 0) {
            setFieldValue('exames', []);
            setMaterial(null);
        }

        if (disableEmpresas) {
            setFieldValue('empresa', defaultEmpresa);
            setEmpresa(defaultEmpresa);
        }

        dadosSelecaoExame.limparExame();
    }
    useEffect(() => {
        setUfSolicitante(ufLaboratorio)
    }, [ufLaboratorio]);

    useEffect(() => {            
            setListaConvenio(listConvenio)              
    },[listConvenio])  

    return (
        <Grid container spacing={3}>
            <Grid container item>
                <Grid item xs={12} sm={6}>
                    <Typography variant="h4">
                        Dados da amostra
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} align="right">
                    <Typography variant="body2">
                        *Campos obrigatórios
                    </Typography>
                </Grid>
            </Grid>    
            

            <Grid container item spacing={3}>
                <Grid item xs={12} sm={8}>
                    <div className={classes.textFieldContainer}>
                        <TextField
                            autoFocus
                            label='Número da etiqueta pré-impressa*'
                            value={values.numeroEtiqueta}
                            onChange={(event) => setFieldValue('numeroEtiqueta', event.target.value)}
                            className={"largura-maxima"}
                            variant='outlined'
                            InputProps={{
                                inputComponent: MascaraNumeroEtiqueta,
                                classes: {
                                    notchedOutline: classes.notchedOutline
                                }
                            }}
                            onBlur={() => setCamposTiveramFoco({
                                ...camposTiveramFoco,
                                numeroEtiqueta: true
                            })}
                            error={!!errors.numeroEtiqueta && camposTiveramFoco.numeroEtiqueta}
                            inputRef={numeroEtiquetaRef}
                        />
                        {!!errors.numeroEtiqueta && camposTiveramFoco.numeroEtiqueta &&
                            <span className={classes.mensagemErro}>
                                {errors.numeroEtiqueta}
                            </span>
                        }
                    </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Selecao
                        etiqueta="Empresa*"
                        codigo={disableEmpresas ? defaultEmpresa : values.empresa}
                        handleChange={(_, value) => setFieldValue('empresa', value)}
                        className={"largura-maxima"}
                        opcoes={empresas}
                        getOptionLabel={(option) => option.descricao}
                        desativarCampo={disableEmpresas}
                        onBlur={() => setCamposTiveramFoco({
                            ...camposTiveramFoco,
                            empresa: true
                        })}
                        error={errors.empresa && camposTiveramFoco.empresa ? errors.empresa : ""}
                    />
                </Grid>
            </Grid>
            <Grid container item spacing={3}>
                <Grid item xs={12} sm={8}>
                    <Selecao
                        etiqueta="Tipo da amostra*"
                        codigo={values.tipoAmostra}
                        handleChange={(_, value) => setFieldValue('tipoAmostra', value)}
                        className={"largura-maxima"}
                        opcoes={tiposAmostra}
                        getOptionLabel={(option) => option.descricao}
                        onBlur={() => setCamposTiveramFoco({
                            ...camposTiveramFoco,
                            tipoAmostra: true
                        })}
                        error={errors.tipoAmostra && camposTiveramFoco.tipoAmostra ? errors.tipoAmostra : ""}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Selecao
                        etiqueta="Tipo da conservação*"
                        codigo={values.tipoConservacao}
                        handleChange={(_, value) => setFieldValue('tipoConservacao', value)}
                        className={"largura-maxima"}
                        opcoes={tiposConservacao}
                        getOptionLabel={(option) => option.descricao}
                        onBlur={() => setCamposTiveramFoco({
                            ...camposTiveramFoco,
                            tipoConservacao: true
                        })}
                        error={errors.tipoConservacao && camposTiveramFoco.tipoConservacao ? errors.tipoConservacao : ""}
                    />
                </Grid>
            </Grid>
            {!clienteDGKPSC &&
            <Grid item xs={12}>
                <TextField
                    label='Especifique a amostra'
                    value={values.especificacao ?? ''}
                    onChange={(event) => setFieldValue('especificacao', event.target.value)}
                    className={"largura-maxima"}
                    inputProps={{
                        maxLength: LIMITE_CHARS_ESPECIFICACAO,
                    }}
                    InputProps={{
                        style: { height: "89px" },
                        classes: {
                            notchedOutline: classes.notchedOutline
                        }
                    }}
                    multiline
                    variant='outlined'
                />
            </Grid>}
            <Grid item xs={12}>
                <Typography variant="h4" className={"mt-2"}>
                    Dados do pedido
                </Typography>
            </Grid>
            <Grid item xs={clienteDGKPSC ? 8 : 12}>
                <div className={classes.textFieldContainer}>
                    <TextField
                        label='Nome do paciente*'
                        value={values.nomePaciente}
                        onChange={(event) => setFieldValue('nomePaciente', event.target.value)}
                        className={"largura-maxima"}
                        variant='outlined'
                        inputProps={{
                            maxLength: LIMITE_CHARS_NOME_PACIENTE,
                        }}
                        InputProps={{
                            classes: {
                                notchedOutline: classes.notchedOutline
                            }
                        }}
                        onBlur={() => setCamposTiveramFoco({
                            ...camposTiveramFoco,
                            nomePaciente: true
                        })}
                        error={!!errors.nomePaciente && camposTiveramFoco.nomePaciente}
                    />
                    {!!errors.nomePaciente && camposTiveramFoco.nomePaciente &&
                        <span className={classes.mensagemErro}>
                            {errors.nomePaciente}
                        </span>
                    }
                </div>
            </Grid>
            {clienteDGKPSC ?
            <Grid item xs={12} sm={4}>
                <Selecao
                    etiqueta="Sexo*"
                    codigo={values.sexo}
                    handleChange={(_, value) => setFieldValue('sexo', value)}
                    className={"largura-maxima"}
                    opcoes={sexos}
                    getOptionLabel={(option) => option.descricao}
                    onBlur={() => setCamposTiveramFoco({
                        ...camposTiveramFoco,
                        sexo: true
                    })}
                    filterOption={(option, text) =>
                        option.value.toString().toUpperCase().startsWith(text.toUpperCase())
                    }
                    error={errors.sexo && camposTiveramFoco.sexo ? errors.sexo : ""}
                />
            </Grid> 
            : ""}
            <Grid container item spacing={3}>
                <Grid item xs={12} sm={4}>
                    <div className={classes.textFieldContainer}>
                        <TextField
                            label={clienteDGKPSC ? 'CPF*' : 'CPF'}
                            value={values.cpf}
                            onChange={(event) => setFieldValue('cpf', event.target.value)}
                            className={"largura-maxima"}
                            variant='outlined'
                            InputProps={{
                                inputComponent: MascaraCPF,
                                classes: {
                                    notchedOutline: classes.notchedOutline
                                }
                            }}
                            onBlur={() => {if (clienteDGKPSC) setCamposTiveramFoco({
                                ...camposTiveramFoco,
                                cpf: true
                            })}}                            
                            error={!!errors.cpf && (clienteDGKPSC && camposTiveramFoco.cpf) }
                        />
                        {!!errors.cpf && (clienteDGKPSC && camposTiveramFoco.cpf) &&
                            <span className={classes.mensagemErro}>
                                {errors.cpf}
                            </span>
                        }
                    </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <SelecaoData
                            onChange={(data) => setFieldValue(clienteDGKPSC ? 'dataNascimento': 'dataPedido', data)}
                            valor={clienteDGKPSC ? values.dataNascimento || null : values.dataPedido || null}
                            etiqueta= {clienteDGKPSC ? 'Data de nascimento' : 'Data do pedido'}
                            variant='dialog'
                            id={clienteDGKPSC ? 'dataNascimento' : 'dataPedido'}
                            campoRequerido = {clienteDGKPSC}
                        />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        label='Número do pedido'
                        value={values.numeroPedido}
                        onChange={(event) => setFieldValue('numeroPedido', event.target.value)}
                        className={"largura-maxima"}
                        variant='outlined'
                        inputProps={{
                            maxLength: LIMITE_CHARS_NUMERO_PEDIDO,
                        }}
                        InputProps={{
                            classes: {
                                notchedOutline: classes.notchedOutline
                            }
                        }}
                    />
                </Grid>
            </Grid>
            {clienteDGKPSC ? 
            <>
                <Grid container item spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <Selecao
                            etiqueta="Convênio*"
                            codigo={values.convenio}
                            handleChange={(_, value) => setFieldValue('convenio', value)}
                            className={"largura-maxima"}
                            opcoes={listaConvenio}
                            getOptionLabel={(option) => option.nome}
                            onBlur={() => setCamposTiveramFoco({
                                ...camposTiveramFoco,
                                convenio: true
                            })}                          
                           error={errors.convenio && camposTiveramFoco.convenio ? errors.convenio : ""}                           
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                    <div className={classes.textFieldContainer}>
                        <TextField
                            label='Carteira*'
                            value={values.numeroCarteira}
                            onChange={(event) => setFieldValue('numeroCarteira', event.target.value)}
                            className={"largura-maxima"}
                            variant='outlined'
                            InputProps={{
                                classes: {
                                    notchedOutline: classes.notchedOutline
                                }
                            }}
                            onBlur={() => setCamposTiveramFoco({
                                ...camposTiveramFoco,
                                numeroCarteira: true
                            })}                          
                            error={!!errors.numeroCarteira && camposTiveramFoco.numeroCarteira }
                        />
                        {!!errors.numeroCarteira && camposTiveramFoco.numeroCarteira &&
                            <span className={classes.mensagemErro}>
                                {errors.numeroCarteira}
                            </span>
                        }
                    </div>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <SelecaoData
                            onChange={(data) => setFieldValue('dataPedido', data)}
                            valor={values.dataPedido || null}
                            etiqueta='Data do pedido'
                            variant='dialog'
                            id='dataPedido'
                        />
                    </Grid>
                </Grid>
                {dadosSolicitante.length &&
                    dadosSolicitante.map((item, index) => {
                    return (
                        <Grid container item spacing={3} key={item.id}>
                            <Grid item xs={12} sm={8}>
                                <AutoComplete
                                    id={`solicitante-${item.id}`}
                                    placeholder=
                                    {
                                        "Nome do médico solicitante"
                                    }
                                    aberturaOpcoes="top"
                                    defaultOptions={true}
                                    limpavel={true}
                                    loadOptions={loadOptions(
                                       ufSolicitante
                                    )}
                                    getOptionValue={getOptionSolicitantesValue}
                                    getOptionLabel={getOptionSolicitantesLabel}
                                    onChange={handleChangeSolicitante(item ? item.id : null)}
                                    value={item && item.nome ? item : null}
                                    obrigatorio
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                            <Selecao
                                handleChange={(_, value) => setUfSolicitante(value)}
                                etiqueta="UF"
                                id="uf"
                                opcoes={unidadeFederativa}
                                codigo={ufSolicitante}
                                proriedadesPersonalizadas={{ menuPlacement: "top" }}
                                abrirMenuAoFocar={false}
                                getOptionLabel={(option) => option.descricao}
                                desativarCampo={desativarUf}
                            />
                            </Grid>                   
                        </Grid>
                    )}
                )}
                <Grid container item spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="h4">
                            Dados da primeira coleta
                        </Typography>
                    </Grid>
                    <Grid container item spacing={3}>
                        <Grid item xs={12} sm={8}>
                            <SelecaoData
                                onChange={(data) => setFieldValue('dataColeta', data)}
                                valor={values.dataColeta || null}
                                etiqueta='Data da coleta'
                                id='dataColeta'
                                variant='dialog'
                                campoRequerido
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <SelecaoHora
                                onChange={(hora) => setFieldValue('horaColeta', hora)}
                                diaReferencia={values.dataColeta}
                                valor={values.horaColeta || null}
                                variant='dialog'
                                etiqueta='Hora da coleta'
                                id='horaColeta'
                                campoRequerido
                            />
                        </Grid> 
                     </Grid>
                </Grid>
                <Grid container item>
                <Grid item xs={12}>
                    <DadosExame
                        dadosExame={{
                        exame: dadosSelecaoExame.exame,
                        especificacao: dadosSelecaoExame.especificacao
                        }}
                        material={dadosSelecaoExame.material}
                        conservante={dadosSelecaoExame.conservante}
                        handleChangeConservante={dadosSelecaoExame.handleChangeConservante}
                        handleChangeMaterial={dadosSelecaoExame.handleChangeMaterial}
                        handleChange={dadosSelecaoExame.handleChangeExame}
                        exameValido
                        handleInserirExame={handleInserirExame}
                        restringirMaterial={material}
                    />           
                </Grid>     
            </Grid> 
              </>
            : ""}
            <Grid container item spacing={2}>
                {clienteDGKPSC ?
                    <>
                    <Grid item xs={6}>
                        <Typography variant="h4" className={"mt-2"}>
                            Anexar arquivo com o pedido médico
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h4" className={"mt-2"}>
                            Anexar arquivo diverso
                        </Typography>
                    </Grid>                
                    <Grid item xs={6}>
                        <DropzoneArquivos
                            tamanhoMaximoDoArquivo={TAMANHO_MAXIMO_ARQUIVOS_AMOSTRA}
                            tiposAceitos={EXTENSOES_ARQUIVOS_AMOSTRA}
                            onUploadError={handleErroArquivo}
                            onUploadSuccess={(arquivos) => handleSucessoArquivos(arquivos, true)}
                            className={classes.dropzone}
                            singleFile
                            desabilitado={possuiArquivoPedidoMedico ? true: false}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <DropzoneArquivos
                            tamanhoMaximoDoArquivo={TAMANHO_MAXIMO_ARQUIVOS_AMOSTRA}
                            tiposAceitos={EXTENSOES_ARQUIVOS_AMOSTRA}
                            onUploadError={handleErroArquivo}
                            onUploadSuccess={(arquivos) => handleSucessoArquivos(arquivos, false)}
                            className={classes.dropzone}
                            singleFile
                            desabilitado={possuiArquivoDiversos ? true: false}
                        />
                    </Grid>
                    </>
                :
                    <>
                        <Grid item xs={12}>
                            <Typography variant="h4" className={"mt-2"}>
                                Anexar arquivos
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <DropzoneArquivos
                                tamanhoMaximoDoArquivo={TAMANHO_MAXIMO_ARQUIVOS_AMOSTRA}
                                tiposAceitos={EXTENSOES_ARQUIVOS_AMOSTRA}
                                onUploadError={handleErroArquivo}
                                onUploadSuccess={(arquivos) => handleSucessoArquivos(arquivos, undefined)}
                                singleFile={false}
                                className={classes.dropzone}
                            />
                        </Grid>
                    </>                    
                }
                <Grid item xs={12}>
                    <Typography>
                        TAMANHO MÁXIMO: 5MB POR ARQUIVO (PDF, PNG, JPG E JPEG)
                    </Typography>
                </Grid>
            </Grid>
            {arquivos?.length > 0 &&
                <Grid container item>
                    <Grid item xs={12}>
                        <ListagemArquivos
                            arquivos={arquivos}
                            handleBaixarArquivo={handleBaixarArquivo}
                            handleExcluirArquivo={handleExcluirArquivo}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2">
                            {arquivos.length} anexos
                        </Typography>
                    </Grid>
                </Grid>
            }
        </Grid>
    );
}

const MascaraNumeroEtiqueta = criarCampoComMascara("mascaraNumeroEtiqueta", MASCARA_NUMERO_ETIQUETA);
const MascaraCPF = criarCampoComMascaraCPF("mascaraCpf");

const useStyles = makeStyles((theme) => ({
    notchedOutline: {
        borderColor: LIGHT_GRAY_COLOR
    },
    textFieldContainer: {
        display: "flex",
        flexDirection: "column"
    },
    mensagemErro: {
        margin: "4px 0px 0px 8px",
        color: RED,
    },
    dropzone: {
        padding: "32px"
    },
}))

export default DadosCadastroAmostra;